import { render, staticRenderFns } from "./exhibitor-navbar.vue?vue&type=template&id=be4de518&scoped=true"
import script from "./exhibitor-navbar.vue?vue&type=script&lang=js"
export * from "./exhibitor-navbar.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-navbar.vue?vue&type=style&index=0&id=be4de518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4de518",
  null
  
)

export default component.exports